<template>
  <v-card class="d-flex pa-2 flex-column" outlined>
    <v-alert
      v-model="flashError"
      dense
      border="left"
      type="error"
      dismissible
      elevation="2"
    >
      {{ flashErrorMessage }}
    </v-alert>
    <TableSearchFilter
      :search="filterValue"
      @search="updateSearch" 
      @showType="showType"
      :filters="[
        { key: 'created_at', type: 'daterange', required: true, props: { label: 'Tanggal Pengajuan', minDateOffset: 30, includeToday: true } },
      ]"
    />
    <TableView
      :headers="headers"
      :items="allData"
      :options.sync="options"
      :loading="loading"
      :totalData="totalData"
      :customTopActions="true"
      :bodyFilter="true"
      item-key="id"
      table-height="70vh"
    >
    <template v-slot:top>
      <TableTop
          :selectedData="selectedData"
          :loading="loading"
          @clearSelected="clearSelected"
          @openApproveModal="openApproveModal"
          @getData="getData"
          @exportItem="exportItem"
        />
      </template>
    <template v-slot:body-prepend>
      <ForceActiveFilter
        :search="search"
        :dataList="allData"
        :selectedData="selectedData"
        :selectAllData="selectAllData"
        v-on:getDataParent="getData"
        v-on:selectedDataParent="changeSelectedData"
        v-on:selectAllDataParent="changeSelectAllData"
      />
    </template>
    <template v-slot:custom="{ item }">
      <v-checkbox
        class="ma-0"
        dense
        hide-details="true"
        v-model="selectedData"
        :value="item.id"
      />
    </template>
    </TableView>
    <v-dialog v-model="dialogApprove" width="500">
      <ConfirmDialog
        title="Are you sure want to forcea active ?"
        caution="Caution: this action cannot be undone !"
        v-on:confirmParent="confirm"
        v-on:closeCancelParent="() => (dialogApprove = false)"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import requestForceMixin from '../../components/merchant-application/request-force-active/requestForceMixin';
import { ForceActiveFilter, TableTop } from '../../components/merchant-application/request-force-active/components';

export default {
  mixins: [requestForceMixin],
  components: {
    ConfirmDialog: () => import('../../components/ConfirmDialog.vue'),
    TableView: () => import("../../components/@drontVue/components/Table/TableView.vue"),
    TableSearchFilter: () => import("../../components/@drontVue/components/SearchFilter/TableSearchFilter.vue"),
    ForceActiveFilter,
    TableTop
  },
};
</script>

<style>
.max-width-col td {
  white-space: nowrap;
  overflow: hidden;
  max-width: 250px;
  text-overflow: ellipsis;
}
.v-data-table .v-data-table__wrapper {
  height: 100%;
}
</style>
